var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"main"}},[_c('h1',{ref:"title",attrs:{"tabindex":"0"}},[_vm._v("Artist lookup")]),_c('artist-form',{on:{"change":function (ref) {
var searchTerm = ref.searchTerm;
 this$1.searchTerm = searchTerm }}}),_c('artist-song-list',{attrs:{"results":_vm.results,"searchTerm":_vm.searchTerm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }